import { Combobox, SimpleValueComboboxCreatableField, SimpleValueComboboxField } from '@cld/combobox';
import styled, { css } from 'styled-components';

export const comboboxCss = css`
  .cb__control {
    background-color: ${({ theme }) => theme.palette.surface};
    border-color: ${({ theme }) => theme.palette.secondary};
  }
  .cb__placeholder {
    color: ${({ theme }) => theme.palette.secondary};

    svg {
      fill: ${({ theme }) => theme.palette.secondary};
    }
  }
  .cb__indicators > svg {
    fill: ${({ theme }) => theme.palette.secondary};
  }
  .cb__menu [role='listitem'] * {
    font-size: ${({ theme }) => theme.font.size.xxs};
  }
`;

export const StyledSimpleValueComboboxField = styled(SimpleValueComboboxField)`
  ${comboboxCss}
`;

export const StyledSimpleValueComboboxCreatableField = styled(SimpleValueComboboxCreatableField)`
  ${comboboxCss}
`;

export const StyledCombobox = styled(Combobox)`
  ${comboboxCss}
`;
